__turbopack_context__.v({
  "input": "switch-module-scss-module__-VvY2W__input",
  "slider": "switch-module-scss-module__-VvY2W__slider",
  "toggle": "switch-module-scss-module__-VvY2W__toggle",
});
